import LocalTaxiIcon from "@mui/icons-material/LocalTaxi"
import React, { useCallback, useMemo } from "react"
import { Box, Button, CardMedia, Typography, useTheme } from "@mui/material"
import _ from "lodash"
import { PageCard, PageCardContent } from "components/card"
import { AppNavigation } from "containers/AppNavigation"
import { NavigationControl } from "components/kioskHorizontal/navigation"
import { MotionDiv } from "components/motions"
import { useTranslation } from "providers/i18n"
import { QRCode } from "components/QRCode"
import { useNavigate } from "react-router-dom"
import { useExtension } from "hooks/extension/useExtension"
import { useTaxiDetail } from "extensions/em-transportation/hooks/useTaxiDetail"

export const EmTaxiTransportationKioskHPage = ({ Layout = Box }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const theme = useTheme()
  const { extensionConfig } = useExtension()

  const { styleOverrides: bannerStyleOverrides = {} } =
    theme.components[`AppBanner`] || {}
  const sideBarStyleOverrides =
    theme.components[`AppSidebar`]?.styleOverrides || {}
  const { root: bannerRoot } = bannerStyleOverrides
  const { wrapper, body, footer } = sideBarStyleOverrides

  const styleOverrides =
    theme.components[`EmTaxiTransportationPage`]?.styleOverrides || {}
  const {
    root,
    pageCardContent,
    title,
    contentWrapper,
    cardMedia,
    button,
    buttonWrapper,
  } = styleOverrides

  const { styleOverrides: emTransportationPageStyleOverrides = {} } =
    theme.components[`EmTransportationPage`] || {}

  const { qrCode } = emTransportationPageStyleOverrides

  const taxiConfig = useMemo(
    () => _.get(extensionConfig, "em-transportation.options"),
    [extensionConfig]
  )

  const taxiLocationLinks = useMemo(
    () => _.get(taxiConfig, "taxi.locations", []),
    [taxiConfig]
  )

  const { locationLinks, mobileUrl } = useTaxiDetail(
    taxiLocationLinks,
    taxiConfig
  )

  const onClickTaxiLocation = useCallback(
    (id) => {
      navigate(`/maps/place/${id}`)
    },
    [navigate]
  )

  const taxiImage = useMemo(() => _.get(theme, "assets.taxi.url"), [theme])

  return (
    <Layout
      aside={
        <PageCard>
          <Box sx={wrapper}>
            <Box sx={bannerRoot}></Box>
            <Box sx={body}>
              <AppNavigation />
            </Box>
            <Box sx={footer}>
              <NavigationControl />
            </Box>
          </Box>
        </PageCard>
      }
    >
      <PageCard sx={root}>
        <MotionDiv
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <PageCardContent sx={pageCardContent}>
            <Typography variant="h1" component="h1" sx={title}>
              Taxi Stand
            </Typography>
            <CardMedia component="img" image={taxiImage} sx={cardMedia} />
            <Box sx={contentWrapper}>
              <QRCode
                sx={qrCode}
                caption={t("Send to Mobile")}
                url={mobileUrl}
              />
              <Box sx={buttonWrapper}>
                {locationLinks.length > 0 &&
                  locationLinks.map((data) => {
                    const { id, name, location } = data
                    return (
                      <Button
                        key={id}
                        variant="contained"
                        startIcon={<LocalTaxiIcon />}
                        sx={button}
                        onClick={() => onClickTaxiLocation(location?.id)}
                      >
                        {t(name)}
                      </Button>
                    )
                  })}
              </Box>
            </Box>
          </PageCardContent>
        </MotionDiv>
      </PageCard>
    </Layout>
  )
}
